<template>
    <div :class="{'side-form-wrapper': true, 'closing-side-form': animateCloseForm, 'toggle': showShadow}">
        <div class="side-form-shadow" @click="closeForm()"></div>

        <div :class="{'side-form-container': true, 'top-up-side-form': ['new-reminder', 'edit-reminder', 'edit-account', 'new-transaction', 'clear-data', 'delete-account'].includes(currentForm)}">
            <button @click="closeForm()" class="side-form-close-btn">
                <i class="icon icon-times"></i>
            </button>

            <DataManagerSideForm v-if="['clear-data', 'delete-account'].includes(currentForm)" :type="currentForm" />
            <NewTransactionSideForm v-if="currentForm == 'new-transaction'" />
            <AccountSideForm v-if="currentForm == 'new-account'" />
            <AccountSideForm :account="formData.account ? formData.account : null" v-if="currentForm == 'edit-account'" />
            <NewCategorySideForm v-if="currentForm == 'new-category'" />
            <EditCategorySideForm v-if="currentForm == 'edit-category'" :category="formData.category ? formData.category : null" />
            <NewBudgetSideForm v-if="currentForm == 'new-budget'" />
            <RemindersSideForm v-if="currentForm == 'reminders'" />
            <ReminderEditorSideForm v-if="currentForm == 'new-reminder'" />
            <ReminderEditorSideForm :reminder="formData.reminder ? formData.reminder : null" v-if="currentForm == 'edit-reminder'" />
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import AccountSideForm from "@/new/components/SideForms/AccountSideForm.vue";
import NewCategorySideForm from "@/new/components/SideForms/NewCategorySideForm.vue";
import EditCategorySideForm from "@/new/components/SideForms/EditCategorySideForm.vue";
import NewBudgetSideForm from "@/new/components/SideForms/NewBudgetSideForm.vue";
import RemindersSideForm from "@/new/components/SideForms/RemindersSideForm.vue";
import ReminderEditorSideForm from "@/new/components/SideForms/ReminderEditorSideForm.vue";
import NewTransactionSideForm from "@/new/components/SideForms/NewTransactionSideForm.vue";
import DataManagerSideForm from "@/new/components/SideForms/DataManagerSideForm.vue";

export default {
    name: "SideForm",

    components: {
        AccountSideForm,
        NewCategorySideForm,
        EditCategorySideForm,
        NewBudgetSideForm,
        RemindersSideForm,
        ReminderEditorSideForm,
        NewTransactionSideForm,
        DataManagerSideForm
    },

    data: function() {
        return {
            toggle: false,

            animateCloseForm: false,

            currentForm: null,
            formData: null,
        }
    },

    mounted() {
        EventBus.$on('open-side-form', (type, data = null) => {
            this.currentForm = type;
            this.formData = data;

            this.openForm();
        });

        EventBus.$on('close-side-form', () => {
            this.closeForm();
        });
    },

    computed: {
        showShadow() {
            return this.toggle || this.animateCloseForm
        },
    },

    methods: {
        closeForm() {
            this.animateCloseForm = true;

            setTimeout(() => {
                this.toggle = false;
                this.currentForm = null;
            }, 500);

            setTimeout(() => {
                this.animateCloseForm = false;
            }, 600);
        },

        openForm() {
            this.toggle = true;
            this.animateCloseForm = false;
        }
    }
}
</script>